var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgBenefits2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1616 42.3506C41.1616 46.5684 37.73 50 33.5122 50H16.4888C12.271 50 8.83936 46.5684 8.83936 42.3506C8.83936 38.1318 12.271 34.7002 16.4888 34.7002H33.5122C37.73 34.7002 41.1616 38.1318 41.1616 42.3506Z",
    fill: "#F9C4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1611 42.3506C41.1611 46.5684 37.7295 50 33.5117 50H25V34.7002H33.5117C37.7295 34.7002 41.1611 38.1318 41.1611 42.3506Z",
    fill: "#FFB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4104 27.2129C41.4104 36.2412 34.0491 43.5869 25.0002 43.5869C15.9514 43.5869 8.59009 36.2412 8.59009 27.2129C8.59009 23.6728 9.76489 20.167 11.8987 17.3428L25.0002 0L38.1018 17.3428C40.2356 20.167 41.4104 23.6719 41.4104 27.2129Z",
    fill: "#FF6565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4102 27.2129C41.4102 36.2412 34.0488 43.5869 25 43.5869V0L38.1016 17.3428C40.2354 20.167 41.4102 23.6719 41.4102 27.2129Z",
    fill: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.295 27.2422C35.295 32.918 30.6769 37.5362 25.0001 37.5362C19.3234 37.5362 14.7052 32.918 14.7052 27.2422C14.7052 21.5655 19.3234 16.9473 25.0001 16.9473C30.6769 16.9473 35.295 21.5655 35.295 27.2422Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2949 27.2422C35.2949 32.918 30.6768 37.5362 25 37.5362V16.9473C30.6768 16.9473 35.2949 21.5655 35.2949 27.2422Z",
    fill: "#CBE1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5005 25.8428V28.7725H26.4653V31.8086H23.5356V28.7725H20.5005V25.8428H23.5356V22.8076H26.4653V25.8428H29.5005Z",
    fill: "#FF6565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4648 31.8086H25V22.8076H26.4648V25.8428H29.5V28.7725H26.4648V31.8086Z",
    fill: "#FF4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBenefits2);
export default __webpack_public_path__ + "static/media/imgBenefits2.567c08493cb2fdfd39774ed770037768.svg";
export { ForwardRef as ReactComponent };